import { useSelector } from 'react-redux'
import { selectors, isPakOnlyContext } from 'auth/stores/userContext'
import { extractUserContextOverride } from 'utils/productHelpers'
import { withSafeContext } from 'utils/contextHelpers'

export function useUserContext() {
  // Create a safer version of the selectProgramContext selector that
  // handles the case when switching between program types
  const userContext = useSelector(selectors.selectUserContextManager)
  const isPakOnly = isPakOnlyContext(userContext)
  let programConTextSelector = selectors.selectProgramContext

  if (!isPakOnly) {
    programConTextSelector = selectors.selectProgramContextWithSiteSelection
  }

  const safeSelectProgramContext = withSafeContext(programConTextSelector)

  const userContextOverride = extractUserContextOverride()
  if (userContextOverride) {
    try {
      return JSON.parse(atob(userContextOverride))
    } catch (e) {
      console.warn(
        'Failed to parse base64-encoded userContextOverride',
        userContextOverride,
        'error:',
        e,
      )
    }
  }

  // Always use the safe wrapper for all program types to ensure consistent behavior
  // This will help prevent issues when switching between program types
  return useSelector(safeSelectProgramContext)
}

export function useUserContextWithLoading() {
  const userContext = useUserContext()
  const isUserContextLoading = useSelector(
    state => state.userContextManager?.isFetching,
  )
  const hasUserContext =
    !isUserContextLoading &&
    userContext &&
    Object.keys(userContext).length > 0 &&
    userContext?.sites?.length &&
    userContext?.sites?.[0]

  return {
    userContext,
    isUserContextLoading: !hasUserContext,
  }
}
